import { isEmpty } from 'lodash'

export const setLiveUpdates = (updaters, eventsState, { updates, options }) => {
  if (isEmpty(eventsState)) return eventsState

  const updaterNames = Object.keys(updates)

  return updaterNames.reduce(
    (eventsAcc, updaterName) =>
      updaters[updaterName]
        ? updaters[updaterName](eventsAcc, updates[updaterName], options)
        : eventsAcc,
    eventsState,
  )
}
